import * as React from 'react';


class Whatsnew extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Whatsnew.jsx] ";
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div>

                <h1>Whatsnew ARM-CORE-PRODUCT</h1>
                <hr />

                <h3>Rel.0.1.32 (10/06/2021)</h3>
                <ul>
                    <li>Prodotto Quotazione</li>
                </ul>

                <h3>Rel.0.1.30 (22/04/2021)</h3>
                <ul>
                    <li>Sistemato problema coass</li>
                </ul>

                <h3>Rel.0.1.28 (14/04/2021)</h3>
                <ul>
                    <li>Aggiunto versione java e html in homepage, header</li>
                </ul>

                <h3>Rel.0.1.27 (13/04/2021)</h3>
                <ul>
                    <li>Aggiunto funzione nella login per vedere il messaggio di scadenza password come Alert se scade per 30 giorni, come danger se scade dopo 10 giorni</li>
                    <li>Nel caso di password scaduta, nella change pass se non c'e' la mail, ridirect nella pagina di login.</li>
                </ul>

                <h3>Rel.0.1.26 (08/04/2021)</h3>
                <ul>
                    <li> Modifiche per visualizzare la versione di java e di html </li>
                </ul>

                <h3>Rel. 0.1.19  (15/12/2020)</h3>
                <ul>
                    <li> Corretto label Punto Vendita </li>
                    <li> Sistemato Nuova Versione </li>
                    <li> Sistemato Provviggioni Passive </li>
                    <li> Aggiunto flag Nuovo Numero Rinnovo </li>
                </ul>

                <h3>Rel. 0.1.18  (15/12/2020)</h3>
                <ul>
                    <li> Sistemato Creazione Compagnia </li>
                </ul>

                <h3>Rel. 0.1.15  (02/12/2020)</h3>
                <ul>
                    <li> Corretto le label </li>
                </ul>
                <h3>Rel. 0.1.14  (01/12/2020)</h3>
                <ul>
                    <li> Sistameto Boostrap Table</li>
                    <li> Aggiunto Clone Prodotto</li>
                    <li> Sistemato Nuova Versione</li>
                    <li> Aggiunto salvataggio del label</li>
                    <li> Migliorato layout del applicazione</li>
                    <li> Tolto i elementi che non servivano </li>
                    <li> Corretto le label </li>
                    <li> Integrato gli opzioni </li>
                </ul>

                <h3>Rel. 0.1.13  (24/11/2020)</h3>
                <ul>
                    <li> Tolto Search dalle tabelle con select</li>
                    <li> Corretto le label </li>
                </ul>
                <h3>Rel. 0.1.12  (21/11/2020)</h3>
                <ul>
                    <li> Cambiato logo Armundia</li>
                    <li> Arm-Core-Product powered BY Armundia GROUP </li>
                </ul>

                <h3>Rel.0.1.11  (3/11/2020)</h3>
                <ul>
                    <li>Aggiornato arm-gui in 2.0.0 </li>
                    <li>Aggiunto arm-common</li>
                    <li>Aggiunto campi sulla compagnia</li>
                    <li>Sistemato punto vendita sul prodotto</li>
                </ul>
                <h3>Rel.0.1.10  (22/10/2020)</h3>
                <ul>
                    <li>Aggiunto Popper Js</li>
                    <li>Migliorato Navigazione tra Dettaglio-Modifica Prodotto/Micro-Categoria</li>
                    <li>Aggiunto Menu Compangia</li>
                    <li>Aggiunto Punto Vendita e associazione con le compagnie</li>
                    <li>Migliorato il layout di home-page</li>
                    <li>Aggiunto Serivizio DoPrint sul Prodotto</li>
                    <li>Aggiunto le Nuove Document Category</li>
                    <li>Sistemato il problema con micro-categoria Contraenti</li>
                    <li>Aggiunto la possibilita di aggiornare gli intermediari con il produttore tramitte applicazione</li>
                    <li>Migliorato i servizi di Validazione</li>
                    <li>Ordinato i codici Rami sulla garanzia </li>
                    <li>Messo Ramo e Bisogno come campi obbligatori sulla garanzia </li>
                    <li>Sistemato imagini mancanti sul prodotto/micro-categoria/famiglia prodotto </li>
                    <li>Sistemato e migliorato provvigioni passive e attive del prodotto </li>

                </ul>

                <h3>Rel.0.1.9  (19/10/2020)</h3>
                <ul>
                    <li>Aggiunto domainValue sul Applicazione</li>

                </ul>
                <h3>Rel.0.1.8  (12/10/2020)</h3>
                <ul>
                    <li>Aggiunto Sconte Discrezionale sul Intermediario</li>
                </ul>
                <h3>Rel.0.1.7  (07/10/2020)</h3>
                <ul>
                    <li>Aggiunto documenti di polizza</li>
                </ul>
                <h3>Rel.0.1.6  (24/07/2020)</h3>
                <ul>
                    <li>Documenti combatibili con il nuovo versione di ARM-CORE-DOCUMENT</li>
                    <li>Aggiunto Regola JavaScript su Prodotto</li>
                </ul>
                <h3>Rel.0.1.5  (13/07/2020)</h3>
                <ul>
                    <li>Aggiunto Pagamenti sul Prodotto</li>
                    <li>Aggiunto Regola su Prodotto</li>
                </ul>
                <h3>Rel.0.1.4  (03/07/2020)</h3>
                <ul>
                    <li>Aggiunto Contraenti sulla Micro-Categoria</li>
                </ul>
                <h3>Rel.0.1.3  (25/06/2020)</h3>
                <ul>
                    <li>Introduzione arm-core-document</li>
                    <li>Aggiunto le voci Famiglia e Categoria Prodotto</li>
                    <li>Aggiunto Frazionamenti sul Prodotto</li>
                    <li>Aggiunto Documenti Upload sul Prodotto</li>
                    <li>Sistemato i bisogni</li>
                    <li>Sistemato i prodotti della micro-categoria</li>
                    <li>Catalogo Prodotti sul home-page</li>
                </ul>
                <ul>
                    <h3>Rel.0.1.2  (__/05/2020)</h3>
                    <li>Introduzione Documenti sul Prodotto</li>
                </ul>
                <h3>Rel.0.1.1  (17/04/2020)</h3>

                <h1>Whatsnew ARM-CORE-PRODUCT</h1>
                <hr />
                <h3>Rel.0.1.0  (__/03/2020)</h3>
                <ul>
                    <li>Introduzione tabelle al posto dei domini - #5559</li>
                </ul>
                <h3>Rel.0.0.5  (12/03/2020)</h3>
                <ul>
                    <li>cambiamento da aguiNpm15 a arm-gui</li>
                    <li>modifiche per compatibilità integrazione: arm-core-product / bad</li>
                </ul>
                <h3>Rel.0.0.4  (28/02/2020)</h3>
                <ul>
                    <li>OrdVis su Micro-categorie #5460</li>
                    <li>Ruoli e Autorizzazioni su pagina profilo</li>
                </ul>
                <h3>Rel.0.0.3  (27/02/2020)</h3>
                <ul>
                    <li>(solo front) Aggiunto menu Famiglie Prodotti con visualizzazione e editing Famiglie Prodotto,Categorie e Ambito</li>
                </ul>

                <h3>Rel.0.0.2  (04/12/2019)</h3>
                <ul>
                    <li>upgrade boostrap 4.4.1</li>
                </ul>

                <h3>Rel.0.0.0.1  (13/12/2018)</h3>
                <ul>
                    <li>upgrade boostrap 4.1.3</li>
                </ul>

            </div>
        );
    }
}


export default Whatsnew;